var _g, _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSplashEnsLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 194,
    height: 194,
    viewBox: "0 0 194 194",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_361:174)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M168 93C168 132.212 136.212 164 97 164C57.7878 164 26 132.212 26 93C26 53.7878 57.7878 22 97 22C136.212 22 168 53.7878 168 93Z",
    fill: "url(#paint0_linear_361:174)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.5303 84.8159C67.4337 86.7382 69.6696 90.5378 69.6696 90.5378L95.5182 48L70.2907 65.5367C68.7875 66.535 67.5542 67.8863 66.6996 69.4713C65.5507 71.8624 64.9402 74.4745 64.9109 77.125C64.8817 79.7754 65.4343 82.4002 66.5303 84.8159Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2879 98.8229C56.5727 102.892 57.7276 106.853 59.6751 110.442C61.6226 114.03 64.3179 117.163 67.5804 119.631L95.4842 139C95.4842 139 78.026 113.954 63.3005 89.0315C61.8097 86.3985 60.8075 83.5197 60.3419 80.5329C60.1358 79.1804 60.1358 77.8047 60.3419 76.4523C59.958 77.1605 59.2127 78.6106 59.2127 78.6106C57.7195 81.642 56.7027 84.8836 56.1976 88.2221C55.9068 91.7512 55.937 95.2992 56.2879 98.8229Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M127.476 102.184C126.573 100.262 124.337 96.4622 124.337 96.4622L98.4881 139L123.716 121.475C125.219 120.476 126.452 119.125 127.307 117.54C128.457 115.147 129.069 112.533 129.098 109.881C129.127 107.228 128.574 104.601 127.476 102.184Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M137.718 88.1771C137.433 84.1082 136.279 80.1468 134.331 76.5582C132.384 72.9696 129.688 69.8366 126.426 67.3691L98.5219 48C98.5219 48 115.969 73.0461 130.706 97.9685C132.192 100.602 133.191 103.481 133.653 106.467C133.859 107.82 133.859 109.195 133.653 110.548C134.037 109.84 134.782 108.389 134.782 108.389C136.275 105.358 137.292 102.116 137.797 98.7779C138.092 95.2491 138.065 91.7011 137.718 88.1771Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6996 69.4713C67.5542 67.8863 68.7875 66.535 70.2907 65.5367L95.5182 48L69.6695 90.5491C69.6695 90.5491 67.411 86.7495 66.5302 84.8272C65.4326 82.41 64.879 79.7831 64.9083 77.1306C64.9375 74.478 65.549 71.8639 66.6996 69.4713ZM56.2879 98.8229C56.5727 102.892 57.7276 106.853 59.6751 110.442C61.6226 114.03 64.3179 117.163 67.5804 119.631L95.4842 139C95.4842 139 78.026 113.954 63.3005 89.0315C61.8097 86.3985 60.8075 83.5197 60.3419 80.5329C60.1358 79.1804 60.1358 77.8047 60.3419 76.4523C59.958 77.1605 59.2127 78.6106 59.2127 78.6106C57.7195 81.642 56.7027 84.8836 56.1976 88.2221C55.9068 91.7512 55.937 95.2992 56.2879 98.8229ZM127.431 102.195C126.527 100.273 124.291 96.4734 124.291 96.4734L98.4881 139L123.716 121.475C125.219 120.476 126.452 119.125 127.307 117.54C128.457 115.147 129.069 112.533 129.098 109.881C129.127 107.228 128.574 104.601 127.476 102.184L127.431 102.195ZM137.673 88.1884C137.388 84.1194 136.233 80.158 134.286 76.5694C132.338 72.9808 129.643 69.8479 126.381 67.3803L98.5219 48C98.5219 48 115.969 73.0461 130.706 97.9685C132.192 100.602 133.191 103.481 133.653 106.467C133.859 107.82 133.859 109.195 133.653 110.548C134.037 109.84 134.782 108.389 134.782 108.389C136.275 105.358 137.292 102.116 137.797 98.7779C138.092 95.2491 138.065 91.7011 137.718 88.1771L137.673 88.1884Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_361:174",
    x: 0,
    y: 0,
    width: 194,
    height: 194,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 13
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_361:174"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_361:174",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_361:174",
    x1: 120.584,
    y1: 180.83,
    x2: -17.4333,
    y2: -62.0994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44BCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.378795,
    stopColor: "#7298F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A099FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSplashEnsLogo);
export default __webpack_public_path__ + "static/media/SplashENSLogo.5a2495f5566d65a68093df555dadcd40.svg";
export { ForwardRef as ReactComponent };